import { useMemo, useSyncExternalStore } from "react";
import { useAuth } from "@/context/AuthContext.jsx";
import { getMembershipCopy } from "./membershipI18n.js";
import { useI18n } from "@/coquille-bridge";
import {
  findMembershipForUsername,
  getMembershipStore,
  subscribeMembership,
} from "./membershipStore.js";
import { isActiveMember } from "./membershipEngine.js";
import { isBlackDragonActive } from "./blackDragonEngine.js";
import { canViewHealthRecord } from "./healthPermissions.js";

function subscribe(cb) {
  return subscribeMembership(cb);
}

function getSnapshot() {
  return getMembershipStore();
}

export function useMembershipStore() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

export function useMembershipCopy() {
  const { lang } = useI18n();
  const locale = lang === "en" ? "en" : "fr";
  return { locale, copy: getMembershipCopy(locale) };
}

export function useCurrentMembership() {
  const { username, role } = useAuth();
  const store = useMembershipStore();
  return useMemo(() => {
    const found = findMembershipForUsername(username);
    const membership = found.membership;
    const credential = found.credential;
    const linked = (credential?.linkedMembershipIds || [])
      .map((id) => store.memberships.find((m) => m.id === id))
      .filter(Boolean);
    const viewer = {
      role,
      username,
      membershipId: membership?.id,
      linkedMembershipIds: credential?.linkedMembershipIds || linked.map((m) => m.id),
    };
    return {
      store,
      membership,
      credential,
      linked,
      viewer,
      isActive: isActiveMember(membership),
      isBlackDragon: isBlackDragonActive(membership),
      canViewOwnHealth: canViewHealthRecord(viewer, membership, store.settings),
    };
  }, [store, username, role]);
}
